module.exports = __webpack_public_path__ + "static/media/car.ac3b635a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/car.jpg
// module id = 46
// module chunks = 0